import { Component, Input, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
})
export class ErrorModalComponent implements OnInit {
  @Input() errorDescription: string = 'errorModal.loginError';
  @Input() errorAction: { text: string; action: () => void } = {
    text: 'errorModal.loginErrorAction',
    action: () => console.log('hgel'),
  };
  constructor() {}

  ngOnInit() {}
}
